var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSlashedEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_2",
    width: 24,
    height: 24,
    "data-name": "Layer 2",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#4f5373}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye-off"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7322",
    d: "M4.71 3.29a1 1 0 1 0-1.42 1.42l5.63 5.63a3.5 3.5 0 0 0 4.74 4.74l5.63 5.63a1 1 0 1 0 1.42-1.42zM12 13.5a1.5 1.5 0 0 1-1.5-1.5v-.07l1.56 1.56z",
    className: "cls-2",
    "data-name": "Path 7322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7323",
    d: "M12.22 17c-4.3.1-7.12-3.59-8-5a13.7 13.7 0 0 1 2.24-2.72L5 7.87a15.89 15.89 0 0 0-2.87 3.63 1 1 0 0 0 0 1c.63 1.09 4 6.5 9.89 6.5h.25a9.48 9.48 0 0 0 3.23-.67l-1.58-1.58a7.74 7.74 0 0 1-1.7.25z",
    className: "cls-2",
    "data-name": "Path 7323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7324",
    d: "M21.87 11.5c-.64-1.11-4.17-6.68-10.14-6.5a9.48 9.48 0 0 0-3.23.67l1.58 1.58a7.74 7.74 0 0 1 1.7-.25c4.29-.11 7.11 3.59 8 5a13.7 13.7 0 0 1-2.29 2.72L19 16.13a15.89 15.89 0 0 0 2.91-3.63 1 1 0 0 0-.04-1z",
    className: "cls-2",
    "data-name": "Path 7324"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSlashedEye);
export default __webpack_public_path__ + "static/media/icon-slashed-eye.96eabd5a79cace0ba8780f12bbec3ea2.svg";
export { ForwardRef as ReactComponent };